import {useTranslate} from '@tolgee/react'
import {Box, DialogHeader, DialogFooter, Text, Button} from '@chakra-ui/react'
import {dialog} from '@cypro/ui/components'

export interface ShiftFutureSequenceSibling {
  id: string
  currentDate: number
  newDate: number
  willLoseValidation: boolean
}

function onClose() {
  dialog.close('shift-future-sequences', true)
}

export function ShiftFutureSequencesDialog({
  onConfirm,
}: {
  onConfirm: (shift: boolean) => void | Promise<unknown>
}) {
  const {t} = useTranslate('common')

  return (
    <>
      <DialogHeader>
        <Box display={'flex'} flexDirection={'column'} gap="1">
          <Text fontWeight={'semibold'} fontSize={'lg'}>
            {t('therapy_sequence.shift_future.title')}
          </Text>
          <Text fontWeight={'normal'} fontSize={'md'} color="fg.muted">
            {t('therapy_sequence.shift_future.description')}
          </Text>
        </Box>
      </DialogHeader>


      <DialogFooter display="flex" justifyContent="flex-end" gapX="3">
        <Button
          variant="outline"
          onClick={async () => {
            await onConfirm(false)
            onClose()
          }}
        >
          {t('therapy_sequence.shift_future.only_this_dose')}
        </Button>
        <Button
          onClick={async () => {
            await onConfirm(true)
            onClose()
          }}
          colorPalette="cyan"
        >
          {t('therapy_sequence.shift_future.shift_also')}
        </Button>
      </DialogFooter>
    </>
  )
}
